import vuexI18n from "vuex-i18n";
import { createPinia } from "pinia";

import Vue from "vue";

import "@/bootstrap";
import store from "@/apps/landing/store";
import { i18n } from "@/services/i18n";

import AuthLoginForm from "@/modules/auth/components/AuthLoginForm.vue";
import Toc from "@/components/Toc.vue";
import JoinForm from "@/components/join/form.vue";

Vue.use(vuexI18n.plugin, store);
Vue.i18n.set(window.Laravel.locale);

i18n.init(store);
i18n.setLocale(window.Laravel.locale).then(() => {
    //
});

const pinia = createPinia();

import { initShared } from "@/apps/landing/shared";
import { initCatalog } from "@/apps/landing/catalog";
import FeedbacksForm from "@/components/feedbacks/form.vue";
import AuthRegister from "@/components/auth/register.vue";

new Vue({
    el: "#app",
    pinia,
    components: {
        AuthLoginForm,
        Toc,
        FeedbacksForm,
        JoinForm,
        AuthRegister,
    },
    mounted() {
        initShared();
        initCatalog();
    },
});
